import React, { useEffect } from "react";
import classes from "./textImageArray.module.scss";
import { FormattedMessage } from "react-intl";
import FormattedHTMLMessage from "../FormattedHTMLMessage";

const TextImageArray = ({
  header,
  headerId,
  title,
  titleId,
  content,
  contentId,
  image,
  setFooterVisibilityReq,
}) => {
  useEffect(() => {
    setFooterVisibilityReq({ isFooterVisible: true });
  }, []);

  return (
    <div className={classes.Container}>
      {header && (
        <div className={classes.Header}>
          <FormattedMessage
            defaultMessage={header}
            id={headerId ? headerId : header}
          />
        </div>
      )}
      {image && (
        <>
          <div className={classes.Title}>
            <FormattedHTMLMessage
              defaultMessage={title}
              value={title}
              id={titleId ? titleId : title}
            />
          </div>
          <div className={classes.Content}>
            <FormattedHTMLMessage
              id={contentId ? contentId : content ? content : "default"}
              value={content}
            />
          </div>
          <img src={image} className={classes.Image} alt="text array" />
        </>
      )}
    </div>
  );
};

export default TextImageArray;
